import { Fragment, h } from "preact";
import { RouterProps } from "preact-router";
import { Container, ToastViewer } from "uitoolkit";
import { usePageTitle } from "hooks";
import { Sidebar } from "components/sidebar";
import { useLlmProviderOffers } from "services/backend/personas";
import { useMemo } from "preact/hooks";
import { DataTableTyped, TypedTableColummn, TypedTableConfig, useTypedTableConfiguration } from "components/table";

type DenormalizedOffer = {
    modelName: string;
    modelIdentifier: string;
    providerName: string;
    cpmCachedTokens: number;
    cpmInputTokens: number;
    cpmOutputTokens: number;
}

const getColumnId = (item: DenormalizedOffer) => item.modelIdentifier ?? "";

const defaultConfig: TypedTableConfig = { sortColumn: "Name", sortOrder: "descending" };

export function ModelsPage(props: {} & RouterProps) {
    usePageTitle("Models");

    const providerOffersResult = useLlmProviderOffers();
    const rows = useMemo(() => providerOffersResult.result?.chat.providers.flatMap(p => p.offers.map(o => ({
        modelName: o.model.name,
        modelIdentifier: o.modelIdentifier,
        providerName: p.name,
        cpmCachedTokens: o.cpmCachedTokens,
        cpmInputTokens: o.cpmInputTokens,
        cpmOutputTokens: o.cpmOutputTokens
    } as DenormalizedOffer))) ?? [], [providerOffersResult.result]);

    const allColumns = useMemo<TypedTableColummn<DenormalizedOffer>[]>(() => [
        {
            name: "Name",
            key: "modelName"
        },
        {
            name: "Identifier",
            key: "modelIdentifier"
        },
        {
            name: "Provider",
            key: "providerName",
        },
        {
            name: "Cached tokens",
            getter: (item: DenormalizedOffer) => item.cpmCachedTokens,
        },
        {
            name: "Input tokens",
            getter: (item: DenormalizedOffer) => item.cpmInputTokens,
        },
        {
            name: "Output tokens",
            getter: (item: DenormalizedOffer) => item.cpmOutputTokens
        },
    ], []);

    console.log("---", rows, allColumns);

    const { visibleData, visibleColumns, sortColumn, sortOrder, onColumnClicked } = useTypedTableConfiguration(rows, allColumns);

    console.log("allColumns", allColumns, "visibleColumns", visibleColumns);

    return (
        <Fragment>
            <Container class="row grow maxheight-100vh overflow-y-hidden">
                <Sidebar page="models" />
                <Container class="flex-column overflow-y-auto grow">
                    <Container class="p-4 pt-0 bg-primary gap-16 flex-column grow maxwidth">
                        <div style={{ paddingTop: "16px" }}>
                            <h2>Models</h2>
                            <br/>

                            <DataTableTyped
                                showHeader
                                columns={visibleColumns}
                                items={visibleData || []}
                                sortColumn={sortColumn?.name}
                                sortOrder={sortOrder}
                                onColumnClicked={onColumnClicked}
                                getItemKey={getColumnId}
                            />

                        </div>
                    </Container>
                </Container>
            </Container>
            <ToastViewer />
        </Fragment>
    );
}
